
import { Options, Vue } from 'vue-class-component'
import { mapState } from 'vuex'
import ShareBtn from '@/components/ShareBtn.vue'

@Options({
  components: { ShareBtn },
  data() {
    return {
        type: '',
    };
  },
  computed: {
    ...mapState(["aid", "userInfo", "countInfo"])
  },
  methods: {
    returnHome() {
      this.$router.replace('/')
    },
  },
  mounted() {
    if(this.$route.query) {
        this.type = this.$route.query.type;
    }
    this.$common.pageLoaded();
    this.$common.track("load", "进入我的成绩页");
  }
})
export default class Status extends Vue {}
